function confirm_meetings_notice() {
  var ret = true, ret2 = true;
  if ($('#radio-remind-1').prop('checked')) {
    ret = confirm('未回答メンバーにメールで再通知します。よろしいですか?');
  }
  if (ret && $('#radio-notice-1').prop('checked')) {
    if ($('#meeting-decide-event-date').val() === '') {
      ret2 = false;
      show_dialog_error('確定日時の案内通知にチェックが入っていますが、通知開催日が決定されていません');
    } else {
      ret2 = confirm('確定日時の案内をメールで通知します。よろしいですか?');
    }
  }
  return ret && ret2;
}

// Export function to make it globally available
window.confirm_meetings_notice = confirm_meetings_notice;
